[
	{
		"code": "OFICINAS",
		"name": "001 PRECIOS OFICINAS",
		"currency": "EUR"
	},
	{
		"code": "WEB",
		"name": "01 TARIFA BASE WEB",
		"currency": "EUR"
	},
	{
		"code": "WEB-PR",
		"name": "05 TARIFA PAGO ONLINE",
		"currency": "EUR"
	},
	{
		"code": "BR-15",
		"name": "10 BROKERS -15%",
		"currency": "EUR"
	},
	{
		"code": "BR-15-PR",
		"name": "11 BROKERS -15% PREPAID",
		"currency": "EUR"
	},
	{
		"code": "LC",
		"name": "15 LOW COST",
		"currency": "EUR"
	},
	{
		"code": "LC-PR",
		"name": "16 LOW COST PREPAID",
		"currency": "EUR"
	},
	{
		"code": "CanOm",
		"name": "1Canarias-Omega",
		"currency": "EUR"
	},
	{
		"code": "CanOm Excess",
		"name": "1Canarias-Omega Excess",
		"currency": "EUR"
	},
	{
		"code": "LC-B",
		"name": "20 LOW COST BROKER",
		"currency": "EUR"
	},
	{
		"code": "LC-B-PR",
		"name": "21 LOW COST BROKER PREPAID",
		"currency": "EUR"
	},
	{
		"code": "BR-25",
		"name": "25 BROKER -25% PREPAID",
		"currency": "EUR"
	},
	{
		"code": "SC-PP",
		"name": "30 Sunny Cars Prepaid Pricelist",
		"currency": "EUR"
	},
	{
		"code": "CRTRW",
		"name": "35 CARTRAWLER EXCESS",
		"currency": "EUR"
	},
	{
		"code": "CRTRW ZERO",
		"name": "40 CARTRAWLER ZERO",
		"currency": "EUR"
	},
	{
		"code": "EMOCIONATE23",
		"name": "999 EMOCIONATE",
		"currency": "EUR"
	},
	{
		"code": "Res-Aw",
		"name": "999 Reservaway",
		"currency": "EUR"
	},
	{
		"code": "KK-TT",
		"name": "9999 KURT KONRAD TOP TRAINING",
		"currency": "EUR"
	},
	{
		"code": "Aurumcars Prepaid",
		"name": "Aurumcars Prepaid - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "Aurumcars Prepaid G1",
		"name": "Aurumcars Prepaid - Canarias.com GOLD 1",
		"currency": "EUR"
	},
	{
		"code": "Aurumcars LC Prepaid",
		"name": "Aurumcars Prepaid - Tenerifecar",
		"currency": "EUR"
	},
	{
		"code": "AutoEurope Prepaid",
		"name": "AutoEurope Prepaid - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "AutoEurope LC Pr",
		"name": "AutoEurope Prepaid - TenerifeCar",
		"currency": "EUR"
	},
	{
		"code": "BookingGroup",
		"name": "BookingGroup - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "BSP Prepaid",
		"name": "BSP Prepaid - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "Carflexi",
		"name": "Carflexi - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "Carflexi-OI",
		"name": "Carflexi Canarias Otras islas",
		"currency": "EUR"
	},
	{
		"code": "Carflexi CUG",
		"name": "Carflexi CUG - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "Carflexi ECR",
		"name": "Carflexi ECR - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "CTW CUG P-LC",
		"name": "Cartrawler CUG Prepaid Tenerifecar",
		"currency": "EUR"
	},
	{
		"code": "Cartrawler Prepaid",
		"name": "Cartrawler Prepaid Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "Cartrawler P-LC",
		"name": "Cartrawler Prepaid Tenerifecar",
		"currency": "EUR"
	},
	{
		"code": "Clarify",
		"name": "Clarify - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "Corp-Tinoleggio",
		"name": "Corporate Flat Net Rates - Tinoleggio",
		"currency": "EUR"
	},
	{
		"code": "Discover LC",
		"name": "DiscoverCars - Tenerife.com",
		"currency": "EUR"
	},
	{
		"code": "Discover CGU PP",
		"name": "DiscoverCars CGU Prepaid - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "Discover LC CGU PP",
		"name": "DiscoverCars CGU Prepaid - Tenerifecar",
		"currency": "EUR"
	},
	{
		"code": "Discover Prepaid",
		"name": "DiscoverCars Prepaid - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "Discover LC Prepaid",
		"name": "DiscoverCars Prepaid - Tenerifecar",
		"currency": "EUR"
	},
	{
		"code": "Discover LC-SD PP",
		"name": "DiscoverCars SIN TARJETA  Prepaid - Tenerifecar",
		"currency": "EUR"
	},
	{
		"code": "Discover WL PP",
		"name": "DiscoverCars WL Prepaid - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "Discover LC WL PP",
		"name": "DiscoverCars WLPrepaid - Tenerifecar",
		"currency": "EUR"
	},
	{
		"code": "Discover",
		"name": "DiscoversCars - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "DYS NR Prepaid",
		"name": "DoYouSpain NR Prepaid - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "Doyouspain Prepaid",
		"name": "DoYouSpain Prepaid - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "Ebookers",
		"name": "Ebookers - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "Enjoy",
		"name": "Enjoy Car Hire - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "Expedia M. Prepaid",
		"name": "Expedia Group Members Prepaid - Canarais.com",
		"currency": "EUR"
	},
	{
		"code": "Expedia Prepaid",
		"name": "Expedia Group Prepaid - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "ExplorerCars",
		"name": "ExplorerCars - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "FairCarRent Prepaid",
		"name": "FairCarRent Prepaid - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "FlexibleAutos-OI",
		"name": "FlexibleAutos Canarias Otras islas",
		"currency": "EUR"
	},
	{
		"code": "FlexibleAutos",
		"name": "FlexibleAutos Prepaid - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "FlexibleAutos LC",
		"name": "FlexibleAutos Prepaid - TenerifeCar",
		"currency": "EUR"
	},
	{
		"code": "GreenCar",
		"name": "GreenCar Tenerife",
		"currency": "EUR"
	},
	{
		"code": "LocalRent",
		"name": "LocalRent - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "LocalRent LC",
		"name": "LocalRent - TenerifeCar",
		"currency": "EUR"
	},
	{
		"code": "Offugo",
		"name": "Offugo - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "OrbitCarHire",
		"name": "OrbitCarHire - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "Rentaholiday",
		"name": "Rentaholiday - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "Rentalcar Genius 2",
		"name": "Rentalcars Genius 2 Prepaid - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "Rentalcar Genius Pr",
		"name": "Rentalcars Genius Prepaid - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "Rentalcars Prepaid",
		"name": "Rentalcars Prepaid - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "RC-OH-PP",
		"name": "Rentalcars Prepaid Nocturnos - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "Rentcars C",
		"name": "Rentcar - Tenerifecar",
		"currency": "EUR"
	},
	{
		"code": "Rentcars C Prepaid",
		"name": "Rentcar Prepaid - Tenerifecar",
		"currency": "EUR"
	},
	{
		"code": "RentCarla",
		"name": "RentCarla - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "Rentcars",
		"name": "Rentcars - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "Rentcars LC",
		"name": "Rentcars - Tenerifecar",
		"currency": "EUR"
	},
	{
		"code": "Rentcars Prepaid",
		"name": "Rentcars Prepaid - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "Rentcars LC Prepaid",
		"name": "Rentcars Prepaid - Tenerifecar",
		"currency": "EUR"
	},
	{
		"code": "ReservAway",
		"name": "ReservAway - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "SUNNYTEMP",
		"name": "Sunnycars Temporary pricelist",
		"currency": "EUR"
	},
	{
		"code": "Tinoleggio",
		"name": "Tinoleggio - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "Tinoleggio Prepaid",
		"name": "Tinoleggio Prepaid - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "TourOperador",
		"name": "TourOperador - Tinoleggio",
		"currency": "EUR"
	},
	{
		"code": "TravelShift Prepaid",
		"name": "TravelShift Prepaid  - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "VipCar",
		"name": "VipCar - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "VipCar LC",
		"name": "VipCar - TenerifeCar",
		"currency": "EUR"
	},
	{
		"code": "WEB-BASIC",
		"name": "WEB - BASICO",
		"currency": "EUR"
	},
	{
		"code": "WEB Fuel",
		"name": "WEB - BASICO Fuel",
		"currency": "EUR"
	},
	{
		"code": "Web-LC",
		"name": "WEB - Low Cost",
		"currency": "EUR"
	},
	{
		"code": "WEB-PREPAID",
		"name": "WEB - PREPAGO",
		"currency": "EUR"
	},
	{
		"code": "Web Fuel PP",
		"name": "Web - PREPAGO - fuel",
		"currency": "EUR"
	},
	{
		"code": "WiseCar",
		"name": "WiseCar - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "WiseCar C",
		"name": "WiseCar - Tenerifeca",
		"currency": "EUR"
	},
	{
		"code": "WiseCar LC",
		"name": "WiseCar - Tenerifecar",
		"currency": "EUR"
	},
	{
		"code": "Zest Prepaid",
		"name": "Zest - Canarias.com",
		"currency": "EUR"
	},
	{
		"code": "Zest Prepaid LC",
		"name": "Zest - Tenerifecar",
		"currency": "EUR"
	},
	{
		"code": "Zuzuche Prepaid",
		"name": "Zuzuche Prepaid - Canarias.com",
		"currency": "EUR"
	}
]